import { render, staticRenderFns } from "./QualificationsDelete.vue?vue&type=template&id=50bb2ece&scoped=true&"
import script from "./QualificationsDelete.vue?vue&type=script&lang=js&"
export * from "./QualificationsDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bb2ece",
  null
  
)

export default component.exports